import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import defined from '~app/core/defined';

import ImageBlob from './ImageBlob';

class WildlifeImage extends Component {

  state = {
    highResImageObjectUrl: null,
    highResRect: null,
  };

  componentWillMount() {
    this.updateHighResImageState(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateHighResImageState(nextProps);
  }

  updateHighResImageState(props) {
    const {selectedSpeciesContent, selectedSpeciesImage} = props;

    if (defined(selectedSpeciesImage) && selectedSpeciesImage !== this.state.highResImageObjectUrl) {
      // Record the rect that was active when the high res image was set.
      // This allows us to continue to use that rect, even in the interval
      // between loading a new selectedSpeciesContent (which contains the rect
      // info), and loading a new selectedSpeciesImage (which occurs
      // asynchronously).
      this.setState({
        highResImageObjectUrl: selectedSpeciesImage,
        highResRect: this.extractImageRect(selectedSpeciesContent),
      });
    }
    else if (!defined(selectedSpeciesImage)) {
      this.setState({
        highResImageObjectUrl: null,
        highResRect: null,
      });
    }
  }

  render() {
    const {selectedSpeciesContent, imageSheets} = this.props;

    if (defined(selectedSpeciesContent)) {

      const imageSheet = this.extractImageSheet(selectedSpeciesContent, imageSheets);
      const imageRect = this.extractImageRect(selectedSpeciesContent);

      let imageJsx = null;
      if (defined(this.state.highResImageObjectUrl) && defined(this.state.highResRect)) {
        imageJsx = this.renderImage(this.state.highResImageObjectUrl, this.state.highResRect);
      }
      else if (defined(imageSheet) && defined(imageRect)) {
        imageJsx = this.renderThumbnail(imageSheet, imageRect);
      }
      else {
        imageJsx = this.renderMissingImage();
      }

      return (
        <div className="WildlifeImage">
          {imageJsx}
        </div>
      );
    }
    return null;
  }

  renderImage(imageUrl, imageRect) {
    const {width, height} = this.extractImageSize(imageRect, 170.0);

    return (
      <div
        className="WildlifeImage__image"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <ImageBlob
          imageUrl={imageUrl}
          style={{
            width: `${width}px`,
            height: `${height}px`,
          }}
        />
      </div>
    );
  }

  renderThumbnail(imageSheet, imageRect) {
    const {width, height, scale} = this.extractImageSize(imageRect, 170.0);

    // Use background position and the real width, height of the image in the
    // sprite sheet to slice out the image.
    // Then apply the background-size scaling to resize the image to our target
    // display size.
    return (
      <div
        className="WildlifeImage__thumbnail"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <ImageBlob
          imageUrl={imageSheet}
          style={{
            width: `${imageRect.w}px`,
            height: `${imageRect.h}px`,
            backgroundPosition: `-${imageRect.x}px -${imageRect.y}px`,

            transform: `scale(${scale})`,
            transformOrigin: 'left top',
            display: 'inline-block',
            backgroundSize: 'auto',
          }}
        />
      </div>
    );
  }

  renderMissingImage() {
    return (
      <div className="WildlifeImage__missing">
        <p className="WildlifeImage__missingImageTitle">
          No image available
        </p>
      </div>
    );
  }

  extractImageSheet(speciesContent, imageSheets) {
    return (defined(speciesContent.image_sheet) ?
        imageSheets[speciesContent.image_sheet] :
        null);
  }

  extractImageRect(speciesContent) {
    return {
      x: speciesContent.image_x,
      y: speciesContent.image_y,
      w: speciesContent.image_width,
      h: speciesContent.image_height,
    };
  }

  extractImageSize(imageRect, frameSize) {
    // Compute a width and height that maintains the image aspect ratio
    // while scaling up to our desired frameSize px by frameSize px.
    // Also compute the scale factor needed to achieve that size.
    let width = 0.0;
    let height = 0.0;
    let scale = 1.0;
    if (imageRect.w > imageRect.h) {
      width = frameSize;
      height = width * (imageRect.h / imageRect.w);
      scale = width / imageRect.w;
    }
    else {
      height = frameSize;
      width = height * (imageRect.w / imageRect.h);
      scale = height / imageRect.h;
    }

    return {
      width,
      height,
      scale,
    };
  }
}

WildlifeImage.propTypes = {
  selectedSpeciesContent: PropTypes.object,
  selectedSpeciesImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

// Do not access any wildlife store elements here!
// Those must be passed as explicit props.
const mapStateToProps = (state) => ({
  imageSheets: state.database.imageSheets,
});

export { WildlifeImage };
export default connect(mapStateToProps)(WildlifeImage);



// WEBPACK FOOTER //
// ./src/components/WildlifeImage.js